import React from 'react';

import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { TemplateListRow } from 'src/components/template/template-list/TemplateList';
import type {
  WorkflowListGridRow,
  WorkflowListRow,
} from 'src/components/workflow/workflow-list/WorkflowsList';
import type { LabelSubset } from 'src/types';
import { WorkflowLabelList } from 'src/workflow/labels';

// Note: This constant is used by other components like WorkflowPartiesPopover
export const labelPopoverOffsetPx = 12;

/** Group headers and grid-generated rows (aggregation footer) carry no labels. */
function getIsLabelledRow(
  row: WorkflowListGridRow | TemplateListRow
): row is TemplateListRow | WorkflowListRow {
  return row.__typename === 'Workflow';
}

export function WorkflowListLabelCell({
  row,
}: GridCellParams<WorkflowListGridRow | TemplateListRow, LabelSubset[]>) {
  if (!getIsLabelledRow(row)) return null;

  return (
    <WorkflowLabelList
      numDisplayedLabels={4}
      popoverProps={{
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
        style: { transform: `translateY(4px)` },
        transformOrigin: { horizontal: 'left', vertical: 'top' },
      }}
      workflow={row}
    />
  );
}
